import { render, staticRenderFns } from "./PatientRequierd.html?vue&type=template&id=2f32d452&"
import script from "./PatientRequierd.js?vue&type=script&lang=js&"
export * from "./PatientRequierd.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports